export default __webpack_public_path__ + "static/media/face_statistics_locations_icons_retail.d5415b3c.svg";